import * as React from 'react';
import { useParams, Link } from 'react-router-dom';
import { LocationTrackingSchedule, LocationCheckLog } from 'cb-model';
import {
  Display,
  IsAllowed,
  NavIconContainer,
  PageTitle,
  PaginatorAndListSettings,
  QuerySingle,
  Search,
  Section,
  useCacheQuery,
} from 'gossamer-front-end';
import { getFilter, QueryOptions } from 'gossamer-unified';
import { Button } from 'react-bootstrap';

/**
 * Location Tracking Schedule Display Page
 *
 * Display details for a single location tracking schedule
 */
export const LocationTrackingScheduleDisplay = (): React.JSX.Element => {
  const params = useParams();

  // Query for location check logs for this schedule
  const [queryOptions, setQueryOptions] = React.useState({
    where: { and: [getFilter('location_tracking_schedule_id', 'eq', params.key, 'hidden')] },
    order: LocationCheckLog.defaultSort,
  } as QueryOptions);
  const gCacheQueryItem = useCacheQuery(LocationCheckLog, queryOptions);

  return (
    <>
      <NavIconContainer entityId={LocationTrackingSchedule.id} />
      <PageTitle verb="Display" entity={LocationTrackingSchedule} keyValue={params.key} />

      <Section>
        <QuerySingle entity={LocationTrackingSchedule} keyValue={params.key} render={Display} fieldGroup="main" />
        <IsAllowed entity={LocationTrackingSchedule} action="update">
          <Link to={`/admin/location-tracking-schedule/update/${params.key}`}>
            <Button size="sm" variant="primary">
              Update
            </Button>
          </Link>
        </IsAllowed>
      </Section>

      <Section title="Days of the Week">
        <QuerySingle entity={LocationTrackingSchedule} keyValue={params.key} render={Display} fieldGroup="days" />
      </Section>

      <Section title="Location Check Logs">
        <PaginatorAndListSettings
          entity={LocationCheckLog}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
